import countryCodes from './countries-dialcode-details';

const countryCodeArray = Object.values(countryCodes);

export default function getSelectedCountryInfo(selectedDialCode, country = 'US') {
  const countryCodeInfo = countryCodeArray.filter(({ iso2, code }) => (
    iso2 === selectedDialCode || code === selectedDialCode));
  if (countryCodeInfo.length > 1) {
    return countryCodes[country];
  }
  return countryCodeInfo.pop() || countryCodes.US;
}
